import { Injectable } from "@angular/core";
import { Platform, Events } from "ionic-angular";

import { Firebase } from "@ionic-native/firebase";

import { Observable } from "rxjs/Observable";

@Injectable()
export class FirebasePluginProvider {
  constructor(
    private events: Events,
    private firebase: Firebase,
    private platform: Platform
  ) {}

  hasPermission(): Promise<{ isEnabled: boolean }> {
    return this.firebase.hasPermission();
  }

  grantPermission(): Promise<any> {
    if (this.platform.is("ios")) {
      return this.firebase.grantPermission();
    } else {
      return new Promise((resolve, reject) => {
        resolve();
      });
    }
  }

  getToken(): Promise<any> {
    return this.firebase.getToken();
  }

  getTokenWithGrantPermission(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.hasPermission().then(
        res => {
          const successGetToken = (token: string) => {
            resolve(token);
          };
          const failGetToken = error => {
            resolve(error);
            console.log("fail get token");
          };
          if (res.isEnabled) {
            this.getToken().then(successGetToken, failGetToken);
            console.log("is enabled");
          } else {
            // permissionがない場合は取りに行く
            this.grantPermission().then(
              res => {
                // 許可
                this.getToken().then(successGetToken, failGetToken);
              },
              error => {
                // 許可されなかった
                console.log("error grant permission");
                reject(error);
              }
            );
          }
          return this.firebase.getToken();
        },
        error => {
          console.log("fail has permission");
          reject(error);
        }
      );
    });
  }

  onTokenRefresh(): Observable<any> {
    return this.firebase.onTokenRefresh();
  }

  setupOnNotification(): void {
    this.onNotificationOpen().subscribe(
      data => {
        console.log("****** notification Received");
        console.log(data);
        this.events.publish("update:unread-num");
      },
      error => {
        console.log("****** notification Received error");
        console.log(JSON.stringify(error));
      }
    );
  }

  setBadgeNumber(num: number): Promise<any> {
    return this.firebase.setBadgeNumber(num);
  }

  clearBadgeNum(): Promise<any> {
    return this.setBadgeNumber(0);
  }

  getBadgeNum(): Promise<any> {
    return this.firebase.getBadgeNumber();
  }

  incrementBadgeNum(num: number): void {
    this.getBadgeNum().then(data => {
      this.firebase.setBadgeNumber(data + 1);
    });
  }

  private onNotificationOpen(): Observable<any> {
    return this.firebase.onNotificationOpen();
  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase/firebase-plugin.ts